<app-form (onsubmit)="submit()">
  <div class="flex justify-evenly gap-4 flex-wrap">
    <app-select #yearSelect placeholder="Year" [required]="true" [options]="years" (selectedChange)="onYearChange($event)" [selected]="lookupStore.vehicle.selected_year() ?? ''" class="w-full sm:w-1/2"></app-select>

    <app-select #makeSelect placeholder="Make" [required]="true" [options]="makes()" [disabled]="makesDisabled()" (selectedChange)="onMakeChange($event)"  [selected]="lookupStore.vehicle.selected_make() ?? ''" class="w-full sm:w-1/2"/>

    <app-select #modelSelect placeholder="Model" [required]="true" [options]="models()" [disabled]="modelsDisabled()" (selectedChange)="onModelChange($event)" [selected]="lookupStore.vehicle.selected_model() ?? ''" class="w-full sm:w-1/2"/>

    <app-select #submodelSelect placeholder="Submodel" [required]="true" [options]="submodels()" [disabled]="submodelsDisabled()" (selectedChange)="onSubmodelChange($event)" [selected]="lookupStore.vehicle.selected_submodel() || ''" class="w-full sm:w-1/2"/>

    <app-select-with-button #fitmentSelect placeholder="Package" [required]="true" [options]="fitments()" [disabled]="fitmentsDisabled()" [buttonDisabled]="!lookupStore.vehicle().selected_fitment" (buttonClick)="alternateSizesModalOpen.set(true)" (selectedChange)="onFitmentChange($event)" [selected]="selectedFitmentValue()" class="w-full sm:w-1/2" (keyup.enter)="submit()">
        <app-icons  id="lookup-alternate-fitments" icon="plus-minus" svgClass=""></app-icons>
    </app-select-with-button>
  </div>

  <div class="mt-4">
    <app-button variant="primary" type="submit">
      View Results
    </app-button>
  </div>
</app-form>

<app-alternate-fitments-modal [(isOpen)]="alternateSizesModalOpen" (onSubmitSearch)="onAlternateSearchSubmit($event)"/>
